// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--UQz-f";
export var pricingCards = "styles-module--pricingCards--Xl9mv";
export var card = "styles-module--card--KPBFH";
export var right = "styles-module--right--mrH8u";
export var monthly = "styles-module--monthly--XWwhB";